/**
 * Created by zhaoxu on 2018/4/19.
 */

export default function install(Vue) {
  Vue.prototype.$openNewWindow = function (opt) {
    let routeData = this.$router.resolve(opt, this.$route);
    window.open(routeData.href, '_blank');
  };
}
